// import React, { useState, useEffect } from "react";
// import Navbar from "../Hero/Navbar/Navbar";
// import Footer from "../Footer/Footer";
// import { Phone, Mail, MapPin, Clock, Send, CheckCircle, MessageSquare } from "lucide-react";

// const ContactPage = () => {
//   const [formStatus, setFormStatus] = useState({
//     submitted: false,
//     submitting: false,
//     info: { error: false, msg: null }
//   });
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           observer.disconnect();
//         }
//       },
//       { threshold: 0 }
//     );

//     const element = document.getElementById("contact-section");
//     if (element) {
//       observer.observe(element);
//     }

//     return () => {
//       if (element) {
//         observer.unobserve(element);
//       }
//     };
//   }, []);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setFormStatus(prevStatus => ({ ...prevStatus, submitting: true }));


//     console.log("getting e for contact form.............",e.target);
    
//     // Simulate form submission
//     setTimeout(() => {
//       setFormStatus({
//         submitted: true,
//         submitting: false,
//         info: { error: false, msg: "Message sent successfully!" }
//       });
//     }, 1500);
//   };
//   return (
//     <>
//       {/* <Navbar /> */}
//       <section id="contact" className="py-16 bg-gradient-to-b from-white to-indigo-50">
//         <div id="contact-section" className="max-w-6xl mx-auto px-4">
//           <div className="text-center mb-12">
//             <h2 className="text-5xl md:text-6xl font-bold text-gray-400 uppercase opacity-10 mb-2">
//               Contact Us
//             </h2>
//             <h3 className="text-4xl md:text-5xl font-bold -mt-8 relative z-10 bg-gradient-to-r from-indigo-600 to-indigo-400 bg-clip-text text-transparent">
//               GET IN TOUCH
//             </h3>
//             <p className="text-gray-600 mt-2">
//               We'd love to hear from you. Here's how you can reach us.
//             </p>
//           </div>

//           <div className="grid md:grid-cols-2 gap-12 items-stretch">
//             {/* Contact Information - Modern Left Side */}
//             <div className={`bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
//               {/* Top Illustration */}
//               <div className="bg-gradient-to-r from-indigo-600 to-indigo-400 p-8 relative">
//                 <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-bl-full opacity-10"></div>
//                 <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-tr-full opacity-10"></div>
                
//                 <div className="relative z-10">
//                   <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4">
//                     <MessageSquare className="w-8 h-8 text-white" />
//                   </div>
//                   <h4 className="text-2xl font-bold text-white mb-2">Let's Connect</h4>
//                   <p className="text-indigo-100 mb-4">We're here to help and answer any questions you might have. We look forward to hearing from you.</p>
//                 </div>
//               </div>
              
//               {/* Contact Details */}
//               <div className="p-8">
//                 <div className="space-y-6">
//                   <div className="flex items-center gap-4 group">
//                     <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center group-hover:bg-indigo-200 transition-colors duration-300">
//                       <MapPin className="w-6 h-6 text-indigo-600" />
//                     </div>
//                     <div>
//                       <h5 className="font-semibold text-gray-800 text-lg">Our Location</h5>
//                       <p className="text-indigo-600">
//                         7B, 2nd Floor Street 2 <br />
//                         East Guru Angad Nagar, <br />
//                         Delhi-110092
//                       </p>
//                     </div>
//                   </div>

//                   <div className="flex items-center gap-4 group">
//                     <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center group-hover:bg-indigo-200 transition-colors duration-300">
//                       <Mail className="w-6 h-6 text-indigo-600" />
//                     </div>
//                     <div>
//                       <h5 className="font-semibold text-gray-800 text-lg">Email Us</h5>
//                       <a href="mailto:info@quzy.in" className="text-indigo-600 hover:text-indigo-800 transition-colors font-medium">
//                         info@quzy.in
//                       </a>
//                     </div>
//                   </div>

//                   <div className="flex items-center gap-4 group">
//                     <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center group-hover:bg-indigo-200 transition-colors duration-300">
//                       <Phone className="w-6 h-6 text-indigo-600" />
//                     </div>
//                     <div>
//                       <h5 className="font-semibold text-gray-800 text-lg">Call Us</h5>
//                       <a href="tel:+918882294632" className="text-indigo-600 hover:text-indigo-800 transition-colors font-medium">
//                         +91 8882294632
//                       </a>
//                     </div>
//                   </div>
//                 </div>
                
//                 {/* Social Media Links */}
//                 <div className="mt-8 pt-6 border-t border-gray-100">
//                   <h5 className="font-semibold text-gray-800 mb-4">Connect With Us</h5>
//                   <div className="flex space-x-4">
//                     <a href="#" className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center hover:bg-indigo-200 transition-colors duration-300">
//                       <svg className="w-5 h-5 text-indigo-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                         <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
//                       </svg>
//                     </a>
//                     <a href="#" className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center hover:bg-indigo-200 transition-colors duration-300">
//                       <svg className="w-5 h-5 text-indigo-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                         <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
//                       </svg>
//                     </a>
//                     <a href="#" className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center hover:bg-indigo-200 transition-colors duration-300">
//                       <svg className="w-5 h-5 text-indigo-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                         <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
//                       </svg>
//                     </a>
//                     <a href="#" className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center hover:bg-indigo-200 transition-colors duration-300">
//                       <svg className="w-5 h-5 text-indigo-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                         <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
//                       </svg>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Contact Form - Right Side */}
//             <div className={`bg-white p-8 rounded-xl shadow-lg transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100 delay-300' : 'translate-y-10 opacity-0'}`}>
//               <div className="relative z-10">
//                 <div className="bg-indigo-100 text-indigo-600 py-1 px-3 rounded-full text-sm font-medium inline-block mb-2">
//                   Send a Message
//                 </div>
//                 <h4 className="text-2xl font-bold text-indigo-600 mb-6">We'd love to hear from you</h4>
//               </div>

//               {formStatus.submitted ? (
//                 <div className="flex flex-col items-center justify-center py-12 text-center">
//                   <div className="bg-green-100 p-3 rounded-full mb-4">
//                     <CheckCircle className="w-12 h-12 text-green-500" />
//                   </div>
//                   <h5 className="text-xl font-bold text-gray-800 mb-2">Thank you!</h5>
//                   <p className="text-gray-600 mb-6">Your message has been sent successfully. We'll get back to you soon!</p>
//                   <button 
//                     onClick={() => setFormStatus({ submitted: false, submitting: false, info: { error: false, msg: null } })}
//                     className="bg-gradient-to-r from-indigo-600 to-indigo-400 text-white py-2 px-6 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center gap-2"
//                   >
//                     <Mail className="w-4 h-4" />
//                     Send another message
//                   </button>
//                 </div>
//               ) : (
//                 <form className="space-y-5 relative z-10" onSubmit={handleSubmit}>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     <div>
//                       <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
//                         Your Name
//                       </label>
//                       <input
//                         type="text"
//                         id="name"
//                         className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300 hover:border-indigo-300"
//                         placeholder="David"
//                       />
//                     </div>
//                     <div>
//                       <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
//                         Your Email
//                       </label>
//                       <input
//                         type="email"
//                         id="email"
//                         className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300 hover:border-indigo-300"
//                         placeholder="david@example.com"
//                       />
//                     </div>
//                   </div>

//                   <div>
//                     <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
//                       Subject
//                     </label>
//                     <input
//                       type="text"
//                       id="subject"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300 hover:border-indigo-300"
//                       placeholder="How can we help you?"
//                     />
//                   </div>

//                   <div>
//                     <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
//                       Message
//                     </label>
//                     <textarea
//                       id="message"
//                       rows="5"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300 hover:border-indigo-300 resize-none"
//                       placeholder="Write your message here..."
//                     ></textarea>
//                   </div>

//                   <button
//                     type="submit"
//                     disabled={formStatus.submitting}
//                     className="bg-gradient-to-r from-indigo-600 to-indigo-400 text-white py-3 px-8 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center justify-center gap-2 w-full sm:w-auto"
//                   >
//                     {formStatus.submitting ? 
//                       'Sending...' : 
//                       <>
//                         <Send className="w-4 h-4" />
//                         Send Message
//                       </>
//                     }
//                   </button>
//                 </form>
//               )}
//             </div>
//           </div>

//         </div>
//       </section>
//       {/* <Footer /> */}
//     </>
//   );
// };

// export default ContactPage;

/////////////////////////////////////////////////////////////


import React, { useState, useEffect } from "react";
import Navbar from "../Hero/Navbar/Navbar";
import Footer from "../Footer/Footer";
import { Phone, Mail, MapPin, Clock, Send, CheckCircle, MessageSquare } from "lucide-react";
import * as api from "../../api/index"; // Import the API function

const ContactPage = () => {
  // Form data state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });
  
  // Form validation state
  const [formErrors, setFormErrors] = useState({});
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0 }
    );

    const element = document.getElementById("contact-section");
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value
    });
    
    // Clear error for this field when user starts typing
    if (formErrors[id]) {
      setFormErrors({
        ...formErrors,
        [id]: null
      });
    }
  };

  // Validate form
  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!formData.name.trim()) {
      errors.name = "Name is required";
    }
    
    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Please enter a valid email address";
    }
    
    if (!formData.subject.trim()) {
      errors.subject = "Subject is required";
    }
    
    if (!formData.message.trim()) {
      errors.message = "Message is required";
    }
    
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    
    setFormStatus(prevStatus => ({ ...prevStatus, submitting: true }));

    try {
      // Call the API function with form data
      const response = await api.submitContactForm({
        name: formData.name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message
      });
      
      if (response.success) {
        // Success
        setFormStatus({
          submitted: true,
          submitting: false,
          info: { error: false, msg: "Message sent successfully!" }
        });
      } else {
        // API returned an error
        setFormStatus({
          submitted: false,
          submitting: false,
          info: { error: true, msg: response.error || "Failed to send message. Please try again." }
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setFormStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: "An unexpected error occurred. Please try again later." }
      });
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: ""
    });
    setFormErrors({});
    setFormStatus({ 
      submitted: false, 
      submitting: false, 
      info: { error: false, msg: null } 
    });
  };

  return (
    <>
      {/* <Navbar /> */}
      <section id="contact" className="py-16 bg-gradient-to-b from-white to-indigo-50">
        <div id="contact-section" className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-400 uppercase opacity-10 mb-2">
              Contact Us
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold -mt-8 relative z-10 bg-gradient-to-r from-indigo-600 to-indigo-400 bg-clip-text text-transparent">
              GET IN TOUCH
            </h3>
            <p className="text-gray-600 mt-2">
              We'd love to hear from you. Here's how you can reach us.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-stretch">
            {/* Contact Information - Modern Left Side */}
            <div className={`bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
              {/* Top Illustration */}
              <div className="bg-gradient-to-r from-indigo-600 to-indigo-400 p-8 relative">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-bl-full opacity-10"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-tr-full opacity-10"></div>
                
                <div className="relative z-10">
                  <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4">
                    <MessageSquare className="w-8 h-8 text-white" />
                  </div>
                  <h4 className="text-2xl font-bold text-white mb-2">Let's Connect</h4>
                  <p className="text-indigo-100 mb-4">We're here to help and answer any questions you might have. We look forward to hearing from you.</p>
                </div>
              </div>
              
              {/* Contact Details */}
              <div className="p-8">
                <div className="space-y-6">
                  {/* <div className="flex items-center gap-4 group">
                    <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center group-hover:bg-indigo-200 transition-colors duration-300">
                      <MapPin className="w-6 h-6 text-indigo-600" />
                    </div>
                    <div>
                      <h5 className="font-semibold text-gray-800 text-lg">Our Location</h5>
                      <p className="text-indigo-600">
                        7B, 2nd Floor Street 2 <br />
                        East Guru Angad Nagar, <br />
                        Delhi-110092
                      </p>
                    </div>
                  </div> */}

                  <div className="flex items-center gap-4 group">
                    <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center group-hover:bg-indigo-200 transition-colors duration-300">
                      <Mail className="w-6 h-6 text-indigo-600" />
                    </div>
                    <div>
                      <h5 className="font-semibold text-gray-800 text-lg">Email Us</h5>
                      <a href="mailto:info@quzy.in" className="text-indigo-600 hover:text-indigo-800 transition-colors font-medium">
                        info@quzy.in
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 group">
                    <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center group-hover:bg-indigo-200 transition-colors duration-300">
                      <Phone className="w-6 h-6 text-indigo-600" />
                    </div>
                    <div>
                      <h5 className="font-semibold text-gray-800 text-lg">Call Us</h5>
                      <a href="tel:+918882294632" className="text-indigo-600 hover:text-indigo-800 transition-colors font-medium">
                        +91 8882294632
                      </a>
                    </div>
                  </div>
                </div>
                
                {/* Social Media Links */}
                {/* <div className="mt-8 pt-6 border-t border-gray-100">
                  <h5 className="font-semibold text-gray-800 mb-4">Connect With Us</h5>
                  <div className="flex space-x-4">
                    <a href="#" className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center hover:bg-indigo-200 transition-colors duration-300">
                      <svg className="w-5 h-5 text-indigo-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                      </svg>
                    </a>
                    <a href="#" className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center hover:bg-indigo-200 transition-colors duration-300">
                      <svg className="w-5 h-5 text-indigo-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                      </svg>
                    </a>
                    <a href="#" className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center hover:bg-indigo-200 transition-colors duration-300">
                      <svg className="w-5 h-5 text-indigo-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                      </svg>
                    </a>
                    <a href="#" className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center hover:bg-indigo-200 transition-colors duration-300">
                      <svg className="w-5 h-5 text-indigo-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
                      </svg>
                    </a>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Contact Form - Right Side */}
            <div className={`bg-white p-8 rounded-xl shadow-lg transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100 delay-300' : 'translate-y-10 opacity-0'}`}>
              <div className="relative z-10">
                <div className="bg-indigo-100 text-indigo-600 py-1 px-3 rounded-full text-sm font-medium inline-block mb-2">
                  Send a Message
                </div>
                <h4 className="text-2xl font-bold text-indigo-600 mb-6">We'd love to hear from you</h4>
              </div>

              {/* Show error message if API returns an error */}
              {formStatus.info.error && !formStatus.submitted && (
                <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <p className="text-sm text-red-700">{formStatus.info.msg}</p>
                    </div>
                  </div>
                </div>
              )}

              {formStatus.submitted ? (
                <div className="flex flex-col items-center justify-center py-12 text-center">
                  <div className="bg-green-100 p-3 rounded-full mb-4">
                    <CheckCircle className="w-12 h-12 text-green-500" />
                  </div>
                  <h5 className="text-xl font-bold text-gray-800 mb-2">Thank you!</h5>
                  <p className="text-gray-600 mb-6">Your message has been sent successfully. We'll get back to you soon!</p>
                  <button 
                    onClick={resetForm}
                    className="bg-gradient-to-r from-indigo-600 to-indigo-400 text-white py-2 px-6 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center gap-2"
                  >
                    <Mail className="w-4 h-4" />
                    Send another message
                  </button>
                </div>
              ) : (
                <form className="space-y-5 relative z-10" onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                        Your Name
                      </label>
                      <input
                        type="text"
                        id="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className={`w-full px-4 py-3 border ${formErrors.name ? 'border-red-300 bg-red-50' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300 hover:border-indigo-300`}
                        placeholder="David"
                      />
                      {formErrors.name && (
                        <p className="mt-1 text-sm text-red-600">{formErrors.name}</p>
                      )}
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        Your Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className={`w-full px-4 py-3 border ${formErrors.email ? 'border-red-300 bg-red-50' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300 hover:border-indigo-300`}
                        placeholder="david@example.com"
                      />
                      {formErrors.email && (
                        <p className="mt-1 text-sm text-red-600">{formErrors.email}</p>
                      )}
                    </div>
                  </div>

                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                      Subject
                    </label>
                    <input
                      type="text"
                      id="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className={`w-full px-4 py-3 border ${formErrors.subject ? 'border-red-300 bg-red-50' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300 hover:border-indigo-300`}
                      placeholder="How can we help you?"
                    />
                    {formErrors.subject && (
                      <p className="mt-1 text-sm text-red-600">{formErrors.subject}</p>
                    )}
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Message
                    </label>
                    <textarea
                      id="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleInputChange}
                      className={`w-full px-4 py-3 border ${formErrors.message ? 'border-red-300 bg-red-50' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-300 hover:border-indigo-300 resize-none`}
                      placeholder="Write your message here..."
                    ></textarea>
                    {formErrors.message && (
                      <p className="mt-1 text-sm text-red-600">{formErrors.message}</p>
                    )}
                  </div>

                  <button
                    type="submit"
                    disabled={formStatus.submitting}
                    className="bg-gradient-to-r from-indigo-600 to-indigo-400 text-white py-3 px-8 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center justify-center gap-2 w-full sm:w-auto"
                  >
                    {formStatus.submitting ? 
                      'Sending...' : 
                      <>
                        <Send className="w-4 h-4" />
                        Send Message
                      </>
                    }
                  </button>
                </form>
              )}
            </div>
          </div>

        </div>
      </section>
      {/* <Footer /> */}
    </>
  );
};

export default ContactPage;
